import clickOutside from "@/directives/clickOutside";
import { purify } from '@shared/utils';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("click-outside", clickOutside);
  nuxtApp.vueApp.component('Purify', defineComponent((props) => {
    return () => {
      return h(props.tag, { innerHTML: purify(props.content) })
    }
  }, {
    props: {
      tag: { type: String, default: 'div' },
      content: { type: String, required: true }
    }
  }))
});
